import { memo, useEffect } from 'react'
import { useCookies } from 'react-cookie'

//
import {
    initializeEvent,
    loadStatusUpdate,
    onDocumentVisibilityChange,
    updateRegionalSettings,
    changePrintingMode
} from '../slices/settings'

import { useDispatch, useSelector } from '../store'
import selectorSettings from '../store/selectors/settings'

//
import { SplashScreen } from '../components/splash-screen'
import AppVersionChanged from '../components/popups/app_version_changed'
import utilsCookies from '../utils/cookies'
import mainPrint from '../utils/main-print'

const InnerApp = memo((props) => {
    const settingsStatus = useSelector((state) => state.settings.status || [])
    const dispatch = useDispatch()

    const [cookies, setCookie] = useCookies(['cmpmrf'])

    //
    const setCampaignCookie = () => {
        const { is_valid, name, value, options } =
            utilsCookies.getCampaignCookieInfo()

        if (!is_valid) return false

        setCookie(name, value, options)
        return true
    }

    const handleOnChangePrintMode = (is_printing) => {
        dispatch(changePrintingMode(is_printing))
    }

    //
    useEffect(() => {
        setCampaignCookie()
        dispatch(onDocumentVisibilityChange())
        dispatch(initializeEvent())
        dispatch(loadStatusUpdate())

        const handleVisibilityChange = () => {
            dispatch(onDocumentVisibilityChange())
        }

        document.addEventListener('visibilitychange', handleVisibilityChange)

        const mainPrintService = mainPrint(handleOnChangePrintMode)

        // window.addEventListener('beforeprint', mainPrintService.beforePrint, false);
        window.addEventListener(
            'afterprint',
            mainPrintService.afterPrint,
            false
        )

        return () => {
            mainPrintService.onDeconstruct()

            document.removeEventListener(
                'visibilitychange',
                handleVisibilityChange
            )
            // window.removeEventListener('beforeprint', mainPrintService.beforePrint, false);
            window.removeEventListener(
                'afterprint',
                mainPrintService.afterPrint,
                false
            )
        }
    }, [])

    //
    useEffect(() => {
        if (!settingsStatus.is_document_visible) {
            return
        }

        dispatch(updateRegionalSettings())

        //
        const interval = setInterval(
            () => {
                if (!settingsStatus.is_document_visible) {
                    return
                }

                dispatch(updateRegionalSettings())
                dispatch(loadStatusUpdate())
            },
            5 * 60 * 1000
        ) // check every 5 min

        return () => {
            clearInterval(interval)
        }
    }, [settingsStatus.is_document_visible])

    const isAppVersionChanged =
        settingsStatus.reload_page_reason == 'app_version_changed'

    return (
        <>
            {isAppVersionChanged ? <AppVersionChanged /> : <></>}
            {settingsStatus.processing ? <SplashScreen /> : props.children}
        </>
    )
})

export default InnerApp
